import { Box, IconButton } from '@mui/material';

import { useQuery } from '@redwoodjs/web';

import CloseIcon from 'src/assets/images/icons/CloseButtonSVG';
import { Flex } from 'src/components/Flex';
import Loader from 'src/components/Loader/Loader';
import { showErrorToast } from 'src/components/Toasts/toast';
import { GET_ELIGIBILITY_OPTIONS } from 'src/graphql/queries/getEligibilityOptions.query';

import ManageEligibilityCard from './ManageEligibilityCard/ManageEligibilityCard';

type ManageEligibilityModal = {
    title: string;
    closeHandleShowEligibilityModal: () => void;
};

const ManageEligibilityModal = ({
    title,
    closeHandleShowEligibilityModal,
}: ManageEligibilityModal) => {
    const { data, loading } = useQuery(GET_ELIGIBILITY_OPTIONS, {
        onError: () => {
            return showErrorToast('Failed to fetch eligibility data');
        },
    });

    return (
        <Box border="0.5px solid #F3A256" overflow="hidden">
            {loading && <Loader />}
            <Box
                style={{
                    padding: '10px',
                    background: 'linear-gradient(90deg, #FF8008 0%, #FFC837 100%)',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                {/* notning */}
                <h3>{title}</h3>
                <IconButton onClick={closeHandleShowEligibilityModal}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <Flex
                alignItems="flex-start"
                justifyContent="space-between"
                padding="20px"
                gap="16px"
                maxHeight="90%"
            >
                <ManageEligibilityCard
                    title="Terminal Offer"
                    asignedToTerminal="Assigned to Terminal Offer(s)?"
                    data={data?.getEligibilityOptions?.terminalOffers ?? []}
                    name="terminalOffers"
                />
                <ManageEligibilityCard
                    title="Online Offer"
                    asignedToTerminal="Assigned to Online Offer(s)?"
                    data={data?.getEligibilityOptions?.onlineOffers ?? []}
                    name="onlineOffers"
                />
                <ManageEligibilityCard
                    title="MCC"
                    asignedToTerminal="Assigned to MCC?"
                    data={data?.getEligibilityOptions?.mccs ?? []}
                    name="mccs"
                />
            </Flex>
        </Box>
    );
};

export default ManageEligibilityModal;
